<div class="dialog-container">
  <h1 mat-dialog-title>{{ title }}</h1>

  <div mat-dialog-content class="dialog-content">
    <form [formGroup]="form">
      <section class="dialog-fields">
        <mat-form-field appearance="outline">
          <mat-label>Producto</mat-label>
          <input matInput [matAutocomplete]="product" formControlName="idproducto" placeholder="Seleccione un producto">
          <mat-autocomplete autoActiveFirstOption #product="matAutocomplete" [displayWith]="displayProduct" (optionSelected)="productChanged($event.option.value)">
            <mat-option *ngFor="let product of filteredProducts" [value]="product">{{ product.nombre }}</mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="form.controls.idproducto.invalid">Selecciona un producto</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Almacén</mat-label>
          <mat-select formControlName="idalmacen">
            <mat-option *ngFor="let store of stores" [value]="store.id">{{ store.nombre }}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls.idalmacen.invalid">Selecciona un almacén</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Comunidad</mat-label>
          <mat-select formControlName="idcomunidad">
            <mat-option *ngFor="let comunidad of comunidades" [value]="comunidad.id">{{ comunidad.nombre }}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls.idcomunidad.invalid">Selecciona una comunidad</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Proveedor</mat-label>
          <mat-select formControlName="idproveedor">
            <mat-option [value]="''">Todos los proveedores</mat-option>
            <mat-option *ngFor="let proveedor of proveedores" [value]="proveedor.id">
              {{ proveedor.nombre_comercial || proveedor.nombre }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Fecha</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="fecha">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Numeración</mat-label>
          <input matInput formControlName="numeracion">
          <mat-error *ngIf="form.controls.numeracion.invalid">La numeración es obligatoria</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Último</mat-label>
          <input matInput formControlName="ultimo">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Cantidad</mat-label>
          <input matInput type="number" min="1" formControlName="cantidad">
          <mat-error *ngIf="form.controls.cantidad.invalid">Indica una cantidad válida</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Stock</mat-label>
          <input matInput type="number" min="0" formControlName="stock">
          <mat-error *ngIf="form.controls.stock.invalid">Indica un stock válido</mat-error>
        </mat-form-field>
      </section>
    </form>
  </div>

  <div mat-dialog-actions class="actions">
    <button mat-stroked-button (click)="close()">Cancelar</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="saving">
      {{ saving ? 'Guardando...' : 'Guardar' }}
    </button>
  </div>
</div>
